import React, { useMemo } from 'react';
import { Modal, Row, Col, Select, Button, Typography, Table, Checkbox } from 'antd';
import { formatCurrency } from '../../../../utils/formatCurrency';
import { dateFromString } from '../../../../utils/dateFromString';

const { Text } = Typography;

export default function ModalCrearOrdenPago({
  visible,
  onClose,
  proveedores,
  asistencias,
  proveedorSeleccionado,
  setProveedorSeleccionado,
  asistenciasSeleccionadas,
  setAsistenciasSeleccionadas,
  onGenerarOP,
  creandoOrdenPago,
  onPagoDirecto,
  onConcesionados,
  loadingConcesionados
}) {

  const asistenciasFiltradas = useMemo(() => {
    if (!proveedorSeleccionado || !asistencias) return [];

    let filtradas = asistencias.filter(a => a.proveedorID === proveedorSeleccionado);

    if (asistenciasSeleccionadas.length > 0) {
      const clienteSeleccionado = asistenciasSeleccionadas[0].clienteID;
      filtradas = filtradas.filter(a => a.clienteID === clienteSeleccionado);
    }

    return filtradas;
  }, [proveedorSeleccionado, asistencias, asistenciasSeleccionadas]);

  const montoTotal = useMemo(() => {
    return asistenciasSeleccionadas.reduce((sum, a) => sum + (a.costo || 0), 0);
  }, [asistenciasSeleccionadas]);

  const handleSelectAsistencia = (checked, asistencia) => {
    if (checked) {
      setAsistenciasSeleccionadas(prev => [...prev, asistencia]);
    } else {
      setAsistenciasSeleccionadas(prev =>
        prev.filter(a => a.asistenciaID !== asistencia.asistenciaID)
      );
    }
  };

  const isSelected = (asistenciaID) => {
    return asistenciasSeleccionadas.some(a => a.asistenciaID === asistenciaID);
  };

  const handleClose = () => {
    setProveedorSeleccionado(null);
    setAsistenciasSeleccionadas([]);
    onClose();
  };

  return (
    <Modal
      title="Crear Orden de Pago"
      open={visible}
      onCancel={handleClose}
      footer={null}
      width={1300}
      className="pagos-v2-modal"
    >
      <Row gutter={[12, 12]}>
        <Col xs={24}>
          <Select
            placeholder="Selecciona un proveedor"
            style={{ width: '100%' }}
            value={proveedorSeleccionado}
            onChange={(val) => {
              setProveedorSeleccionado(val);
              setAsistenciasSeleccionadas([]);
            }}
            allowClear
            showSearch
            optionFilterProp="children"
          >
            {proveedores?.map(p => (
              <Select.Option key={p.proveedorID} value={p.proveedorID}>
                {p.proveedorNombre}
              </Select.Option>
            ))}
          </Select>
        </Col>
      </Row>

      {proveedorSeleccionado && asistenciasFiltradas.length > 0 && (
        <>
          <Row style={{ marginTop: 16 }}>
            <Col xs={24}>
              <Table
                dataSource={asistenciasFiltradas}
                pagination={false}
                size="small"
                scroll={{ y: 300 }}
                rowKey="asistenciaID"
                columns={[
                  {
                    title: '',
                    width: 50,
                    align: 'center',
                    render: (_, record) => (
                      <Checkbox
                        checked={isSelected(record.asistenciaID)}
                        onChange={(e) => handleSelectAsistencia(e.target.checked, record)}
                      />
                    )
                  },
                  {
                    title: 'ID',
                    dataIndex: 'asistenciaID',
                    key: 'asistenciaID',
                    width: 90
                  },
                  {
                    title: 'Fecha',
                    dataIndex: 'fecha',
                    key: 'fecha',
                    width: 110,
                    render: (val) => dateFromString(val)?.soloFecha || val
                  },
                  {
                    title: 'Cliente',
                    dataIndex: 'cliente',
                    key: 'cliente',
                    width: 180
                  },
                  {
                    title: 'Campaña',
                    dataIndex: 'campania',
                    key: 'campania',
                    width: 200
                  },
                  {
                    title: 'Servicio',
                    dataIndex: 'servicio',
                    key: 'servicio',
                    width: 200
                  },
                  {
                    title: 'Estatus',
                    dataIndex: 'estatusFinalNombre',
                    key: 'estatusFinalNombre',
                    width: 150
                  },
                  {
                    title: 'Costo',
                    dataIndex: 'costo',
                    key: 'costo',
                    width: 120,
                    align: 'right',
                    render: (val) => formatCurrency(val)
                  }
                ]}
              />
            </Col>
          </Row>

          <Row style={{ marginTop: 16 }} gutter={16} align="middle">
            <Col span={12}>
              <Text>Seleccionados: <Text strong>{asistenciasSeleccionadas.length}</Text></Text>
              <Text style={{ marginLeft: 24 }}>Monto Total: <Text strong>{formatCurrency(montoTotal)}</Text></Text>
            </Col>
            <Col span={12} style={{ textAlign: 'right' }}>
              <Button
                type="primary"
                onClick={onGenerarOP}
                disabled={asistenciasSeleccionadas.length === 0}
                loading={creandoOrdenPago}
                style={{ marginRight: 16 }}
              >
                Generar OP
              </Button>
              <Button
                disabled={asistenciasSeleccionadas.length === 0}
                style={{ marginRight: 8 }}
                onClick={onPagoDirecto}
              >
                Pago Directo
              </Button>
              <Button
                disabled={asistenciasSeleccionadas.length === 0}
                onClick={onConcesionados}
                loading={loadingConcesionados}
              >
                Concesionado
              </Button>
            </Col>
          </Row>
        </>
      )}

      {proveedorSeleccionado && asistenciasFiltradas.length === 0 && (
        <Row style={{ marginTop: 16 }}>
          <Col xs={24}>
            <Text type="secondary">No hay asistencias pendientes para este proveedor</Text>
          </Col>
        </Row>
      )}
    </Modal>
  );
}